import { ServiceConfig } from '@user/store/services/config'
import type { ENTITY_TYPES } from '@sales-center/common'

export const baseUrl = ServiceConfig.baseAPIUrl

export const urls = {
  fetchCallTrackingDetails: (type: ENTITY_TYPES, id: number) =>
    `${baseUrl}/${type.toLowerCase()}/${id}/CallTrackingValues`,
}
